<script setup>
import { ref } from 'vue';
import iconChevron from '@client/svg/chevron.svg?raw';
const toggleSpoiler = ref(false);
</script>
<template>
    <div class="accordion" :class="{ 'accordionActive': toggleSpoiler }">
        <div class="accordionHead" @click="toggleSpoiler = !toggleSpoiler">
            <slot name="heading" />
            <div class="iconw" v-html="iconChevron"></div>
        </div>
        <transition name="expand">
            <div class="accordionBody" v-show="toggleSpoiler">
                <slot />
            </div>
        </transition>
    </div>
</template>
<style lang="scss" scoped>
.accordion {
    border-top: 1px solid rgba(0, 0, 0, .12);
    border-bottom: 1px solid rgba(0, 0, 0, .12);
    margin-left: -1rem;
    margin-right: -1rem;
    padding: 0 1rem;

    &Head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        font-size: 16px;
        margin: 12px 0;
        line-height: 24px;
    }

    .iconw {
        transition: transform 0.15s 0s ease;
        font-size: 0.75em;
    }

    &Body {
        max-height: 10000px;
        // max-height: 0;
        // height: auto;
        // overflow: hidden;
        // transition: max-height 0.15s 0s ease;
    }

    &Active {
        .accordionBody {
            // max-height: 10000px;
        }

        .iconw {
            transform: rotate(90deg);
        }

    }
}
.expand-enter-active,
.expand-leave-active {
  transition: height 0.3s ease;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  height: 0;
}

.expand-enter-to,
.expand-leave-from {
  height: auto;
}
</style>